import React, {useState, useEffect} from 'react';
import {Row, Col, Button, FormGroup, Label, Input, Container} from 'reactstrap';
import {connect} from 'react-redux';
import {fetchLoginUser} from '../../reducer/user-reducer';
import {useNavigate} from 'react-router-dom';
import '../../sass/login.scss';
interface configObject {
  user: {
    token: string;
    errorLogin: Object | null;
  };
  configReducer: {
    siteConfig: {
      brandId: string;
    };
  };
}

interface propiedades {
  fetchLoginUser(user: string, password: string, brandId: string): any;
  token: string;
  errorLogin: Object | null;
  brandId: string;
}

interface iPayload {
  payload: string;
}

const Login = (props: propiedades) => {
  const [ndi, setNdi] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const submitButton = () => {
    props.fetchLoginUser(ndi, password, props.brandId).then((res: iPayload) => {
      if (res) {
        localStorage.setItem('token', res.payload);
        navigate('/admin/home');
      }
    });
  };
  useEffect(() => {
    document.body.classList.add('back-image');

    return () => {
      document.body.classList.remove('back-image');
    };
  }, []);
  return (
    <Container>
      <Row>
        <Col
          xs={12}
          md={{size: 5}}
          className="login-box d-flex justify-content-center flex-column"
        >
          <div className="background-text p-3 rounded color-primary">
            {props.errorLogin && <p>error</p>}
            <FormGroup>
              <Label>DNI</Label>
              <Input
                type="number"
                value={ndi}
                onChange={(e) => {
                  setNdi(e.target.value);
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label>Contraseña</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </FormGroup>
            <Button
              onClick={submitButton}
              className="background-primary border-primary w-100"
            >
              Ingresar
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    errorLogin: state.user.errorLogin,
    brandId: state.configReducer.siteConfig.brandId,
  };
};
export default connect(mapStateToProps, {fetchLoginUser})(Login);
